import { useState } from 'react';
import classNames from 'classnames';
import {
  VibeButton,
} from 'vibeguide';
import { FormHelperText } from '@mui/material';
import { Dialpad, Lock } from '@mui/icons-material';
import PasswordRequirements from '../Shared/Password/PasswordRequirements';
import './ResetPasswordForm.scss';

function ResetPasswordForm({
  errors = {},
  confirmationCode = '',
  confirmationCodeError = false,
  confirmationCodeErrorMessage = '',
  onConfirmationCodeChange = () => {},
  resetPassword = () => {},
  passwordValidateChange = () => {},
  resendActivationCode = () => {},
}) {
  const [password, setPassword] = useState('');
  const [isCodeFocus, setIsCodeFocus] = useState(false);
  const [isPasswordFocus, setIsPasswordFocus] = useState(false);

  const onPasswordChange = (e) => {
    const {
      target: {
        value,
      },
    } = e;

    setPassword(value);
    passwordValidateChange(e);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      resetPassword(e);
    }
  };

  return (
    <div
      className="ResetPasswordForm"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      <div
        className="form-title"
        style={{
          fontSize: 18,
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        Reset Password

        <div
          className="form-subtitle"
          style={{
            marginTop: 16,
            fontSize: 12,
            fontWeight: 'normal',
          }}
        >
          Please enter the code sent to your e-mail address, then provide a new password.
        </div>
      </div>

      <form
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 24,
        }}
      >
        <div className={classNames('input-container', { active: isCodeFocus, 'has-error': confirmationCodeError })}>
          <input
            className="login-input"
            type="number"
            placeholder="000000"
            value={confirmationCode}
            onChange={(e) => onConfirmationCodeChange(e)}
            onFocus={() => setIsCodeFocus(true)}
            onBlur={() => setIsCodeFocus(false)}
            onKeyDown={onKeyDown}
            autoFocus
            data-testid="reset-password-activation-code-input"
          />

          <Dialpad className="login-icon pad-icon" />

          {confirmationCodeError && (
            <FormHelperText className="login-error">
              {confirmationCodeErrorMessage}
            </FormHelperText>
          )}
        </div>

        <div className={classNames('input-container', { active: isPasswordFocus })}>
          <input
            className="login-input"
            type="password"
            placeholder="New Password"
            value={password}
            onChange={onPasswordChange}
            onKeyDown={onKeyDown}
            onFocus={() => setIsPasswordFocus(true)}
            onBlur={() => setIsPasswordFocus(false)}
            data-testid="reset-password-new-password-input"
          />

          <Lock className="login-icon password-icon" />
        </div>
      </form>

      <PasswordRequirements
        errors={errors}
      />

      <VibeButton
        style={{
          width: '100%',
          height: 48,
          fontSize: 16,
        }}
        text="Reset Password"
        color="primary"
        disabled={!confirmationCode || errors.errors}
        testId="reset-password-submit-button"
        onClick={resetPassword}
      />

      <VibeButton
        style={{
          width: '100%',
          height: 48,
          fontSize: 16,
        }}
        text="Resend Activation Code"
        color="secondary"
        testId="reset-password-resend-code-button"
        onClick={(e) => resendActivationCode(e)}
      />
    </div>
  );
}

export default ResetPasswordForm;
